define(['backbone'], (Backbone) => Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        display_name: null,
        has_fact: true,
        has_plan: true,
        is_enabled: true
    },
    slug () {
        switch (this.get('name')) {
        case 'targetmail':
            return 'mytarget';
        default:
            return this.get('name');
        }
    }
}));
